import produce from "immer";
import reducerUtils from "../../../../store/reducerUtils";
import ToolPluginActions from "./toolPluginActions";

const initialState = {
  data: {
    toolPlugins: null,
    toolPluginsCounter: 0,
    toolPlugin: null,
    toolPluginSettings: [],
  },
};

export const toolPluginSelectors = {
  getList: (state) => state.toolPlugins.data.toolPlugins,
  getListCounter: (state) => state.toolPlugins.data.toolPluginsCounter,
  getToolPlugin: (state) => state.toolPlugins.data.toolPlugin,
  getToolPluginSettings: (state) => state.toolPlugins.data.toolPluginSettings,
};

const onLoadList = produce((draft, action) => {
  draft.data.toolPlugins = action.toolPlugins;
});

const onListChanged = produce((draft) => {
  draft.data.toolPluginsCounter++;
});

const onToolPluginLoaded = produce((draft, action) => {
  draft.data.toolPlugin = action.toolPlugin;
});

const onSettingsLoaded = produce((draft, action) => {
  draft.data.toolPluginSettings = action.toolPluginSettings ?? [];
});

const onSettingsChanged = produce((draft, action) => {
  draft.data.toolPluginSettings = action.toolPluginSettings ?? [];
});

const handlers = {
  [ToolPluginActions.LIST_LOADED]: onLoadList,
  [ToolPluginActions.LIST_CHANGED]: onListChanged,
  [ToolPluginActions.LOADED]: onToolPluginLoaded,
  [ToolPluginActions.UPDATED]: onToolPluginLoaded,
  [ToolPluginActions.SETTINGS_LOADED]: onSettingsLoaded,
  [ToolPluginActions.SETTINGS_CHANGED]: onSettingsChanged,
};

const toolPluginReducer = reducerUtils.createReducer(initialState, handlers);

export default toolPluginReducer;
